import { useSetRecoilState } from 'recoil';
import {
  FilteredLevels,
  FilteredRoles,
  FilteredSigungus,
  FilteredStacks,
} from '@/src/store/superstack/jobs/FilterStates';
import { useState } from 'react';
import { MSSModal } from '@/src/component/superstack/base/MModal';
import { Radio } from '@/src/component/superstack/base/Radio';
import { ToggleButton } from '@/src/component/superstack/base/ToggleButton';
import { Button } from '@/src/component/superstack/base/Button';
import { SSModal } from '@/src/component/superstack/base/Modal';
import IconTrashBinX from '@/asset/superstack/svgs/icon-trash-bin-x.svg';

import styles from '@/styles/superstack/jobs/modals/FilterApplyModal.module.scss';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

import { handleServerError } from '@/src/utils/ss_utils';
import { deleteFilter, patchFilterNoti } from '@/src/services/superstack/jobs/filters';

const FilterApplyModal = ({
  isFilterApplyModalOpen,
  setIsFilterApplyModalOpen,
  filters,
  setSavedFilters,
}) => {
  const setFilteredStacks = useSetRecoilState(FilteredStacks);
  const setFilteredRoles = useSetRecoilState(FilteredRoles);
  const setFilteredLevels = useSetRecoilState(FilteredLevels);
  const setFilteredSigungus = useSetRecoilState(FilteredSigungus);

  const [selectedFilter, setSelectedFilter] = useState('{}');
  const [selectedFilterId, setSelectedFilterId] = useState(0);

  const applyFilter = () => {
    const data = JSON.parse(selectedFilter);
    if (Object.keys(data).length > 0) {
      {
        data.filteredStacks && setFilteredStacks({ ...data.filteredStacks });
      }
      {
        data.filteredRoles && setFilteredRoles(data.filteredRoles);
      }
      {
        data.filteredLevels && setFilteredLevels(data.filteredLevels);
      }
      {
        data.filteredSigungus && setFilteredSigungus(data.filteredSigungus);
      }
    }
  };
  const toggleFilterNoti = async (filterId, curVal) => {
    try {
      await patchFilterNoti(filterId, curVal);
      setSavedFilters(
        filters.map((savedFilter) =>
          savedFilter.id === filterId
            ? { ...savedFilter, nofitication_enabled: !curVal }
            : savedFilter,
        ),
      );
    } catch (error) {
      handleServerError(error);
    }
  };
  const removeFilter = async (filterId, filterName) => {
    const confirmed = confirm(`${filterName} 필터를 삭제하시겠습니까?`);
    if (!confirmed) {
      return false;
    }

    try {
      await deleteFilter(filterId);
    } catch (error) {
      handleServerError(error);
    }
    setSavedFilters(
      filters.filter((savedFilter) => {
        return savedFilter.id !== filterId;
      }),
    );
  };

  return (
    <SSModal
      isOpen={isFilterApplyModalOpen}
      onSubmit={applyFilter}
      onClose={() => {
        setIsFilterApplyModalOpen(false);
      }}
      customStyle={{ content: { width: '504px' } }}
    >
      <form className={cx('apply-filters')}>
        <section className={cx('table')}>
          <div className={cx('thead')}>
            <div className={cx('tr')}>
              <div className={cx(['th', 'col-first'])}>필터 이름</div>
              <div className={cx(['th', 'col-second'])}>알림 설정</div>
              <div className={cx(['th'])}>관리</div>
            </div>
          </div>
          <div className={cx('tbody')}>
            {filters &&
              filters.map((filter, idx) => {
                return (
                  <div className={cx('tr')} key={idx}>
                    <div className={cx(['td', 'col-first'])}>
                      <Radio
                        size="sm"
                        name="selectedFilter"
                        value={filter.name}
                        checked={filter.id === selectedFilterId}
                        updateContainer={() => {
                          setSelectedFilter(filter.data);
                          setSelectedFilterId(filter.id);
                        }}
                      >
                        {filter.name}
                      </Radio>
                    </div>
                    <div className={cx(['td', 'col-second'])}>
                      <ToggleButton
                        active={filter.notification_enabled}
                        updateContainer={() => {
                          toggleFilterNoti(filter.id, filter.notification_enabled);
                        }}
                      />
                    </div>
                    <div className={cx(['td'])}>
                      <Button
                        type="button"
                        mode="text"
                        size="sm"
                        onClick={() => {
                          removeFilter(filter.id, filter.name);
                        }}
                      >
                        삭제
                      </Button>
                    </div>
                  </div>
                );
              })}
          </div>
        </section>
      </form>
    </SSModal>
  );
};

const MFilterApplyModal = ({
  isFilterApplyModalOpen,
  setIsFilterApplyModalOpen,
  filters,
  setSavedFilters,
}) => {
  const setFilteredStacks = useSetRecoilState(FilteredStacks);
  const setFilteredRoles = useSetRecoilState(FilteredRoles);
  const setFilteredLevels = useSetRecoilState(FilteredLevels);
  const setFilteredSigungus = useSetRecoilState(FilteredSigungus);

  const [selectedFilter, setSelectedFilter] = useState('{}');

  const applyFilter = () => {
    const data = JSON.parse(selectedFilter);
    if (Object.keys(data).length > 0) {
      {
        data.filteredStacks && setFilteredStacks({ ...data.filteredStacks });
      }
      {
        data.filteredRoles && setFilteredRoles(data.filteredRoles);
      }
      {
        data.filteredLevels && setFilteredLevels(data.filteredLevels);
      }
      {
        data.filteredSigungus && setFilteredSigungus(data.filteredSigungus);
      }
    }
  };
  const toggleFilterNoti = async (filterId, curVal) => {
    try {
      await patchFilterNoti(filterId, curVal);
    } catch (error) {
      handleServerError(error);
    }
    setSavedFilters(
      filters.map((savedFilter) =>
        savedFilter.id === filterId
          ? { ...savedFilter, nofitication_enabled: !curVal }
          : savedFilter,
      ),
    );
  };
  const removeFilter = async (filterId, filterName) => {
    const confirmed = confirm(`${filterName} 필터를 삭제하시겠습니까?`);
    if (!confirmed) {
      return false;
    }

    try {
      await deleteFilter(filterId);
    } catch (error) {
      handleServerError(error);
    }
    setSavedFilters(
      filters.filter((savedFilter) => {
        return savedFilter.id !== filterId;
      }),
    );
  };

  return (
    <MSSModal
      isOpen={isFilterApplyModalOpen}
      onSubmit={applyFilter}
      onClose={() => {
        setIsFilterApplyModalOpen(false);
      }}
      title={'저장한 필터'}
    >
      <form className={cx('apply-filters')}>
        <section className={cx('list')}>
          {filters &&
            filters.map((filter, idx) => {
              return (
                <article key={idx} className={cx('card')}>
                  <div className={cx('name-wrapper')}>
                    <Radio
                      size="lg"
                      name="selectedFilter"
                      value={filter.name}
                      checked={selectedFilter === filter.data}
                      updateContainer={() => {
                        setSelectedFilter(filter.data);
                      }}
                    >
                      {filter.name}
                    </Radio>
                    <IconTrashBinX
                      width={21}
                      height={24}
                      onClick={() => {
                        removeFilter(filter.id, filter.name);
                      }}
                    />
                  </div>
                  <div className={cx('content-wrapper')}>
                    <div className={cx('toggle-box')}>
                      <div className={cx('toggle-text')}>해당 필터에 대한 알림톡을 받습니다.</div>
                      <ToggleButton
                        active={filter.notification_enabled}
                        updateContainer={() => {
                          toggleFilterNoti(filter.id, filter.notification_enabled);
                        }}
                      />
                    </div>
                  </div>
                </article>
              );
            })}
        </section>
      </form>
    </MSSModal>
  );
};

export { FilterApplyModal, MFilterApplyModal };
